export default __webpack_public_path__ + "static/media/defaultAvatar.d16664d7.png";